import AlertSystem from './AlertSystem';
import './AlertSystem.scss';

export default AlertSystem;
